module.exports = __webpack_public_path__ + "static/media/fly0101.fad93f66.webp";